//  GAZA_DEPARTMENT
const GAZA = "GAZA";
const B2R_SAB3 = "B2R_SAB3";

// HAIFA_DEPARTMENT
const HAIFA = "HAIFA";

// LOD_DEPARTMENT
const YAFA = "YAFA";
const RAMLA = "RAMLA";

// SAMARIA_DEPARTMENT
const GANIN = "GANIN";
const NABLUS = "NABLUS";
const TULKARM = "TULKARM";

// GALILEE_DEPARTMENT
const SAFED = "SAFED";
const AKKA = "AKKA";
const NAZARETH = "NAZARETH";
const BEISAN = "BEISAN";
const TIBERIAS ='TIBERIAS'

// QUDUS_DEPARTMENT
const QUDUS = "QUDUS";
const RAMALLAH = "RAMALLAH";
const HEBRON = "HEBRCON";

export  {
  GAZA,
  B2R_SAB3,

  HAIFA,

  YAFA,
  RAMLA,
  
  GANIN,
  NABLUS,
  TULKARM,

  SAFED,
  AKKA,
  NAZARETH,
  BEISAN,
  TIBERIAS,

  QUDUS,
  RAMALLAH,
  HEBRON,
};
